  import { lazy, Suspense } from "react";
  import { useLocation, useRoutes,Navigate  } from "react-router-dom";
  import LoadingScreen from "../views/shared/LoadingCamp";
  import NotFound from "../views/shared/NotFound";


  const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { pathname } = useLocation();

    return (
      <Suspense fallback={<LoadingScreen isDashboard={pathname.includes("/")} />}>
        <Component {...props} />
      </Suspense>
    );
  };

    export default function Router() {
      return useRoutes([
        {
          path: "/",
          element: <Navigate to="/homePage" replace />,
          
        },
           { path: "/Qr", element: <Qr /> },
           { path: "/doctorQr", element: <DoctorQr /> },
        {
          path: "/homePage",
          element: <HomePage />,
          children: [
            { path: "", element: <HP_Template />, }, // صفحه اصلی
            { path: "login", element: <Login /> },
            //{ path: "test", element: <Test /> },
            { path: "CallBack", element: <CallBack /> },
            { path: "search/doctor/:drName/:id", element: <HomeAppointmentReservation /> },
            { path: "search/medicalCenters/:persianTitle/:type/:Id", element: <CentersAppointmentReservation /> },
            { path: "reserve/:drName/:policlinicName/:id", element: <CompletingAppointment /> },
            { path: "appointmentRules", element: <AppointmentRules /> },
            { path: "patientAppointment/expertise/:expertiseId/", element: <PatientAppointment /> },
            { path: "patientAppointment/expertise/:expertiseId/:cityId", element: <PatientAppointment /> },
            { path: "patientAppointment/drService/:drService", element: <PatientAppointment /> },
            { path: "patientAppointment/drService/:drService/:cityId", element: <PatientAppointment /> },
            { path: "patientAppointment/doctorDisease/:doctorDiseaseId", element: <PatientAppointment /> },
            { path: "patientAppointment/doctorDisease/:doctorDiseaseId/:cityId", element: <PatientAppointment /> },
            { path: "quizzes", element: <UserQuizzes /> },
            { path: "loans", element: <UserLoans /> },
            { path: "healthMonitoringAlgorithms", element: <UserHealthMonitoringAlgorithms /> },
          
          ],
        },
      {
        path: "auth",
        children: [
          // { path: "register", element: <RegisterUsers /> },
          { path: "login", element: <LoginAndRegisterUsers /> },
          { path: "login/:phoneNumber/:typeId/:recordId", element: <LoginAndRegisterUsers /> },
          { path: "login/:phoneNumber/:typeId/:policlinicId/:recordId", element: <LoginAndRegisterUsers /> },
          
          
        ],
      },
      {
        path: "quizMaster",
        children: [
          {
            path: "dashboard",
            element: <Q_Dashboard/>,
            children: [
              {path:"quizzes",element:<Quizzes/>},
              {path:"quizMasterDashboard",element:<Q_DashboardContent/>},
              {path:"quizMasterQuizCorrection",element:<QuizMasterQuizCorrection/>},
            ]
          },
          {path:"confirmation",element:<Q_Confirmation/>},
         
          
        ],
      },
       {
        path: "healthCenter",
        children: [
          {
            path: "dashboard",
            element: <H_Dashboard/>,
            children: [
             
              {path:"healthCenterDashboard",element:<H_DashboardContent/>},
             {path:"healthCenterReceptions",element:<HealthCenterReceptions/>},
            ]
          },
          {path:"healthCenterBase",element:<HealthCenterBase/>},
         
          
        ],
      },
      {
        path: "organization",
        children: [
          {
            path: "dashboard",
            element: <O_Dashboard/>,
            children: [
             
              {path:"organizationDashboard",element:<O_DashboardContent/>},
              {path:"organizationPatients",element:<OrganizationPatients/>},
              {path:"organizationReport",element:<OrganizationReport/>},
              {path:"OrganizationCharts",element:<OrganizationCharts/>}
            ]
          },
          {path:"organizationBase",element:<OrganizationBase/>},
         
          
        ],
      },
      {
        path: "organizationSystem",
        children: [
          {
            path: "dashboard",
            element: <OrgSystem_Dashboard/>,
            children: [
             
              {path:"organizationSystemDashboard",element:<OrgSystem_DashboardContent/>},
              {path:"organizationSystemPatients",element:<OrganizationSystemPatients/>},
              {path:"organizationSystemReport",element:<OrganizationSystemReport/>}, 
              {path:"organizationSystemCharts",element:<OrganizationSystemCharts/>}
            ]
          },
          {path:"organizationSystemBase",element:<OrganizationSystemBase/>},
         
          
        ],
      },
    
      {
        path: "admin",
        children: [
          { path: "adminLogin", element: <Admin_Login /> },
          {
            path: "dashboard",
            element: <Dashboard />,
            children: [
              { path: "listProvince", element: <ListProvince /> },
              { path: "listBaseUserAddress", element: <ListBaseUserAddress /> },
              { path: "listCities", element: <ListCities /> },
              { path: "listJobGroup", element: <ListJobGroups /> },
              { path: "listJob", element: <ListJob /> },
              { path: "listInsurances", element: <ListInsurances /> },
              { path: "listDegree", element: <ListDegree /> },
              { path: "listGender", element: <ListGender /> },
              { path: "listOrganizationTypes",element: <ListOrganizationTypes />},
              { path: "listBaseUser", element: <ListBaseUser /> },
              { path: "listMainBodyParts", element: <ListMainBodyParts/> },
              { path: "listBodyParts", element: <ListBodyParts/> },
              { path: "listReceptionTypes", element: <ListReceptionTypes/> },
              { path: "listReceptions", element: <ListReceptions/> },
              { path: "listBloodGroups", element: <ListBloodGroups/> },
              { path: "listPaymentTypes", element: <ListPaymentTypes/> },
              { path: "listDrugType", element: <ListDrugType/> },
              { path: "listDrugTimes", element: <ListDrugTimes/> },
              { path: "listDrugDosages", element: <ListDrugDosages/> },
              { path: "listDrugCategories", element: <ListDrugCategories/> },
              { path: "listTestCategories", element: <ListTestCategories/> },
              { path: "listTests", element: <ListTests/> },
              { path: "listAdmin", element: <ListAdmin/> },
              { path: "listSecretaries", element: <ListSecretaries/> },
              { path: "listDisease", element: <ListDisease/> },
              { path: "listDiseaseCategories", element: <ListDiseaseCategories/> },
              { path: "listSymptoms", element: <ListSymptoms/> },
              { path: "listHealthCenters", element: <ListHealthCenters/> },
              { path: "listHealthCenterService", element: <ListHealthCenterService/> },
              { path: "healthCenterService", element: <HealthCenterService/> },
              { path: "listHealthCenterServiceInsurances", element: <ListHealthCenterServiceInsurances/> },
              { path: "listHealthCenterServiceCategory", element: <ListHealthCenterServiceCategory/> },
              { path: "listHealthCenterServices", element: <ListHealthCenterServices/> },
              { path: "listHealthCenterPart", element: <ListHealthCenterPart/> },
              { path: "listHealthCenterRoomType", element: <ListHealthCenterRoomType/> },
              { path: "listHealthCenterRoom", element: <ListHealthCenterRoom/> },
              { path: "listHealthCenterBed", element: <ListHealthCenterBed/> },
              { path: "listRoles", element: <ListRoles/> },
              { path: "listUserRole", element: <ListUserRole/> },
              { path: "listPatients", element: <ListPatients/> },
              { path: "listDoctors", element: <ListDoctors/> },
              { path: "listQuizMaster", element: <ListQuizMaster /> },
              { path: "listLaboratories", element: <ListLaboratories/> },
              { path: "listDrugstores", element: <ListDrugstores/> },
              { path: "listMatab", element: <ListMatab/> },
              { path: "listRadiography", element: <ListRadiography/> },
              { path: "listMedicalSystems", element: <ListMedicalSystems/> },
              { path: "listFellowships", element: <ListFellowships/> },
              { path: "listExpertise", element: <ListExpertise/> },
              { path: "listRadiologyCategories", element: <ListRadiologyCategories/> },
              { path: "listPatientSmokeHistories", element: <ListPatientSmokeHistories/> },
              { path: "listPatientWeightHistories", element: <ListPatientWeightHistories/> },
              { path: "listPeriods", element: <ListPeriods/> },
              { path: "listTestAnswerByPatients", element: <ListTestAnswerByPatients/> },
              { path: "listRadiologyAnswerByPatients", element: <ListRadiologyAnswerByPatients/> },
              { path: "listSupporters", element: <ListSupporters/> },
              { path: "listSupportContracts", element: <ListSupportContracts/> },
              { path: "listDoctorDiseaseRadiology", element: <ListDoctorDiseaseRadiology/> },
              { path: "listDoctorDiseaseTest", element: <ListDoctorDiseaseTest/> },
              { path: "listDoctorExpertise", element: <ListDoctorExpertise/> },
              { path: "listDoctorFellowships", element: <ListDoctorFellowships/> },
              { path: "listDoctorsServicesCategories", element: <ListDoctorsServicesCategories/> },
              { path: "listDoctorsServices", element: <ListDoctorsServices/> },
              { path: "listDoctorServices", element: <ListDoctorServices/> },
              { path: "listDoctorServiceInsurances", element: <ListDoctorServiceInsurances/> },
              { path: "listDiseaseDoctors", element: <ListDiseaseDoctors/> },
              { path: "listDiagnosis", element: <ListDiagnosis/> },
              { path: "listDoctorIntroducePatients", element: <ListDoctorIntroducePatients/> },
             
              { path: "listPatientOperates", element: <ListPatientOperates/> },
              { path: "listDiseaseTests", element: <ListDiseaseTests/> },
              { path: "listDiseaseRadiology", element: <ListDiseaseRadiology/> },
              { path: "ListRadiology", element: <ListRadiology/> },
              { path: "listDrug", element: <ListDrug/> },
              { path: "listDrugInstructions", element: <ListDrugInstructions/> },
              { path: "listDoctorDiseaseDrugs", element: <ListDoctorDiseaseDrugs/> },
              { path: "listDiseaseSymptoms", element: <ListDiseaseSymptoms/> },
              { path: "listPatientDrugs", element: <ListPatientDrugs/> },
              { path: "listDrugstoreDrugs", element: <ListDrugstoreDrugs/> },
              { path: "listRolePermission", element: <ListRolePermission/> },
              { path: "listPermissionCategoryPermissions", element: <ListPermissionCategoryPermissions/> },
              { path: "listSupportRequestSettlements", element: <ListSupportRequestSettlements/> },
              { path: "listDiseaseDrugs", element: <ListDiseaseDrugs/> },
              { path: "listDrugSimilar", element: <ListDrugSimilar/> },
              { path: "listDrugInteraction", element: <ListDrugInteraction/> },
              { path: "listTestDetails", element: <ListTestDetails/> },
              { path: "visitFormPage", element: <VisitFormPage/> },
              { path: "doctorVisitFormPage", element: <DoctorVisitFormPage/> },
              { path: "listAppointmentPatient", element: <ListAppointmentPatient/> },
              { path: "listAppointments", element: <ListAppointments/> },
              { path: "listAppointmentDetails", element: <ListAppointmentDetails/> },
              { path: "listExternalAppointmens", element: <ListExternalAppointmens/> },
              { path: "ListAppointmentOnlineType", element: <ListAppointmentOnlineType/> },
              { path: "listFamily", element: <ListFamily/> },
              { path: "listRiskFactors", element: <ListRiskFactors/> },
              { path: "listDiseaseRiskFactors", element: <ListDiseaseRiskFactors/> },
              { path: "listDiseaseExpertise", element: <ListDiseaseExpertise/> },
              { path: "listLoanTypes", element: <ListLoanTypes/> },
              { path: "listLoanDocuments", element: <ListLoanDocuments/> },
              { path: "listLoans", element: <ListLoans/> },
              {path:"listLender",element:<ListLender/>},
              {path:"listMedicalLaboratoryTitle",element:<ListMedicalLaboratoryTitle/>},
              {path:"listMedicalRadiographyTitle",element:<ListMedicalRadiographyTitle/>},
              {path:"listReferrals",element:<ListReferrals/>},
              {path:"listReferralCategories",element:<ListReferralCategories/>},
              {path:"listFinancialCenter",element:<ListFinancialCenter/>},
              {path:"listBank",element:<ListBank/>},
              {path:"listCreditPoints",element:<ListCreditPoints/>},
              {path:"listBankAccounts",element:<ListBankAccounts/>},
              {path:"listComment",element:<ListComment/>},
              {path:"listQuizPanel",element:<ListQuizPanel/>},
              {path:"listQuizMasterQuizPanel",element:<ListQuizMasterQuizPanel/>},   
              {path:"listQuizCategory",element:<ListQuizCategory/>},
              {path:"listQuizCategoryDetails",element:<ListQuizCategoryDetails/>},
              {path:"listQuestionType",element:<ListQuestionType/>},
              {path:"listQuizType",element:<ListQuizType/>}, 
              {path:"listCourseCategories",element:<ListCourseCategories/>},
              {path:"listCourse",element:<ListCourse/>},
              {path:"listLevelScore",element:<ListLevelScore/>},
              {path:"listQuiz",element:<ListQuiz/>},
              {path:"listQuizCourse",element:<ListQuizCourse/>},
              {path:"listQuizCourseScore",element:<ListQuizCourseScore/>},
              {path:"listQuizScore",element:<ListQuizScore/>},
              {path:"listQuestion",element:<ListQuestion/>},
              {path:"listQuizQuestion",element:<ListQuizQuestion/>},
              {path:"adminQuizCorrection",element:<AdminQuizCorrection/>},
              {path:"listPatientTest",element:<ListPatientTest/>},
              {path:"listPatientRadiology",element:<ListPatientRadiology/>},
              {path:"listInnocence",element:<ListInnocence/>},
              {path:"listOrganizationCategory",element:<ListOrganizationCategory/>},
              {path:"listOrganization",element:<ListOrganization/>},
              {path:"listOrganizationDoctor",element:<ListOrganizationDoctor/>},
              {path:"listOrganizationRoom",element:<ListOrganizationRoom/>},
              {path:"listOrganizationSystem",element:<ListOrganizationSystem/>},
              {path:"listOrganizationPatients",element:<ListOrganizationPatients/>},
              {path:"listOrganizationServantContract",element:<ListOrganizationServantContract/>},
              {path:"listSocialMedia",element:<ListSocialMedia/>},
              {path:"listFrequentlyQuestionCategories",element:<ListFrequentlyQuestionCategories/>},
              {path:"listFrequentlyQuestions",element:<ListFrequentlyQuestions/>},
              {path:"listEquipments",element:<ListEquipments/>},
              {path:"listEquipmentGroups",element:<ListEquipmentGroups/>},
              {path:"listServiceEquipments",element:<ListServiceEquipments/>},
              {path:"listPoliclinicEquipments",element:<ListPoliclinicEquipments/>},
              {path:"listPatientEquipmentSalesInvoices",element:<ListPatientEquipmentSalesInvoices/>},
              {path:"listSmsPanels",element:<ListSmsPanels/>},
              {path:"listNurse",element:<ListNurse/>},
              {path:"listHealthRecordCategory",element:<ListHealthRecordCategory/>},
              {path:"ListHealthRecordCategoryDetails",element:<ListHealthRecordCategoryDetails/>},
              {path:"listHealthRecord",element:<ListHealthRecord/>},
              {path:"listActivityType",element:<ListActivityType/>},
              {path:"listEcg",element:<ListEcg/>},
              {path:"listAltitude",element:<ListAltitude/>},
              {path:"listTimeOfDay",element:<ListTimeOfDay/>},
              {path:"listInjectionType",element:<ListInjectionType/>},
              {path:"listInjectionBodyPart",element:<ListInjectionBodyPart/>},
              {path:"listManufacturer",element:<ListManufacturer/>},
              {path:"listPupilSize",element:<ListPupilSize/>},
              {path:"listSkinObservation",element:<ListSkinObservation/>},
              {path:"listPatientVaccineHistory",element:<ListPatientVaccineHistory/>},
              {path:"listVaccine",element:<ListVaccine/>},
              {path:"listVaccineDoseType",element:<ListVaccineDoseType/>},
              {path:"listVaccineDoseSchedule",element:<ListVaccineDoseSchedule/>},
              {path:"listVaccineType",element:<ListVaccineType/>},
              {path:"listPatientActivityHistory",element:<ListPatientActivityHistory/>},
              {path:"listPatientBloodOxygenLevelHistory",element:<ListPatientBloodOxygenLevelHistory/>},
              {path:"listPatientBloodPressureHistory",element:<ListPatientBloodPressureHistory/>},
              {path:"listPatientBloodSugarHistory",element:<ListPatientBloodSugarHistory/>},
              {path:"listPatientBodyTemperatureHistory",element:<ListPatientBodyTemperatureHistory/>},
              {path:"listPatientConsciousnessLevelHistory",element:<ListPatientConsciousnessLevelHistory/>},
              {path:"listPatientEcgHistory",element:<ListPatientEcgHistory/>},
              {path:"listPatientFluidBalanceHistory",element:<ListPatientFluidBalanceHistory/>},
              {path:"listPatientHealthNote",element:<ListPatientHealthNote/>},
              {path:"listPatientHeartRateHistory",element:<ListPatientHeartRateHistory/>},
              {path:"listPatientOxygenSaturationHistory",element:<ListPatientOxygenSaturationHistory/>},
              {path:"listPatientPainScoreHistory",element:<ListPatientPainScoreHistory/>},
              {path:"listPatientPupilCheckHistory",element:<ListPatientPupilCheckHistory/>},
              {path:"listPatientRespiratoryRateHistory",element:<ListPatientRespiratoryRateHistory/>},
              {path:"listPatientSkinObservationHistory",element:<ListPatientSkinObservationHistory/>},
              {path:"listPatientSleepQualityHistory",element:<ListPatientSleepQualityHistory/>},
              {path:"listMeasurementUnit",element:<ListMeasurementUnit/>},
              {path:"listUnitConversions",element:<ListUnitConversions/>},
              {path:"listHealthMonitoringAlgorithms",element:<ListHealthMonitoringAlgorithms/>},
              {path:"listPatientHealthMonitorings",element:<ListPatientHealthMonitorings/>},
              {path:"listSupportInformation",element:<ListSupportInformation/>},
              {path:"listPackages",element:<ListPackages/>},
              {path:"listTestDeviceCategory",element:<ListTestDeviceCategory/>},
              {path:"listMenstrualCycle",element:<ListMenstrualCycle/>},
              {path:"listTestFormula",element:<ListTestFormula/>},
            ],
          },
        ],
      },
      {
        path:"doctor",
        children: [
          {path:"doctorBase",element:<DoctorBase/>},
          {
            path: "dashboard",
            element: <D_Dashboard/>,
            children: [
              {path:"doctorVisit",element:<DoctorVisit/>},
              {path:"officePatients",element:<OfficePatients/>},
              {path:"listIntroducesDoctor",element:<ListIntroducesDoctor/>},
              {path:"DashboardContent",element:<DashboardContentDoctor/>},
              {path:"reportDoctor",element:<ReportDoctor/>},
            ]
          }
        ]
      },
      {
        path:"secretary",
        children: [
          {path:"secretaryBase",element:<SecretaryBase/>},
          {
            path: "dashboard",
            element: <S_Dashboard/>,
            children: [
              {path:"secretaryDashboard",element:<DashboardContent/>},
              {path:"secretaryPatients",element:<SecretaryPatients/>},
              {path:"secretaryAppointments",element:<SecretaryAppointments/>},
              {path:"listSecretaryAppointmentsAll",element:<ListSecretaryAppointmentsAll/>},
              
              {path:"patientMedicalInformation",element:<PatientMedicalInformation/>},
              {path:"secretaryPatientBoard",element:<SecretaryPatientBoard/>},
            ]
          } ,{path:"secretaryPatientBoard",element:<SecretaryPatientBoard/>},
        ]
      },
    
      {
        path:"patient",
        children: [
          {
            path: "dashboard",
            element: <P_Dashboard/>,
            children: [
              {path:"patient",element:<Patient/>},
              {path:"patientAppointment",element:<PatientAppointment/>},
              {path:"patientAppointment/:expertisId",element:<PatientAppointment/>},
              {path:"appointmentReservation",element:<AppointmentReservation/>},
            
            ]
          },
          {path:"confirmation",element:<Confirmation/>},
          
        ]
      },
      {
        path:"supporter",
        children: [
          {
            path: "dashboard",
            element: <Sup_Dashboard/>,
            children: [
            {path:"patientSupporter",element:<PatientSupporter/>},
            {path:"supporterDashboard",element:<DashboardContent_Supporter/>},
            {path:"settlementRequest",element:<SettlementRequest/>},
            {path:"supporterReport",element:<SupporterReport/>},
            {path:"supportContract",element:<SupportContract/>}
            ]
          }
        ]
      },
      {
        path:"radiography",
        children: [
          {path:"radiographyBase",element:<RadiographyBase/>},
          {
            path: "dashboard",
            element: <Radiography_Dashboard/>,
            children: [
            {path:"radiographyDashboard",element:<RadiographyDashboardContent/>},
            {path:"radiographyReception",element:<RadiographyReception/>},
            {path:"radiographyAppointment",element:<RadiographyAppointment/>},
            
            ]
          }
        ]
      },
      {
        path:"laboratory",
        children: [
          {path:"laboratoryBase",element:<LaboratoryBase/>},
          {
            path: "dashboard",
            element: <Laboratory_Dashboard/>,
            children: [
            {path:"laboratoryDashboard",element:<LaboratoryDashboardContent/>},
            {path:"laboratoryReception",element:<LaboratoryReception/>},
            {path:"laboratoryAppointment",element:<LaboratoryAppointment/>},
            
            ]
          }
        ]
      },
      {
        path:"drugstore",
        children: [
          {path:"drugstoreBase",element:<DrugstoreBase/>},
          {
            path: "dashboard",
            element: <Drugstore_Dashboard/>,
            children: [
            {path:"drugstoreDashboard",element:<DrugstoreDashboardContent/>},
            {path:"drugstoreReception",element:<DrugstoreReception/>},
            {path:"drugstoreAppointment",element:<DrugstoreAppointment/>},
            
            ]
          }
        ]
      },
      {
        path:"lender",
        children: [
          {path:"lenderBase",element:<LenderBase/>},
          {
            path: "dashboard",
            element: <Lender_Dashboard/>,
            children: [
              {path:"lenderDashboard",element:<LenderDashboardContent/>},
              {path:"lenderLoan",element:<LenderLoan/>},
              {path:"loanRequest",element:<LenderLoanRequest/>},
              
            
            ]
          }
        ]
      },
      {
        path:"lenderSystem",
        children: [
          {path:"lenderSystemBase",element:<LenderSystemBase/>},
          {
            path: "dashboard",
            element: <LenderSystem_Dashboard/>,
            children: [
              {path:"lenderSystemDashboard",element:<LenderSystemDashboardContent/>},
              {path:"lenderSystemLoan",element:<LenderSystemLoan/>},
              {path:"lenderSystemLoanRequest",element:<LenderSystemLoanRequest/>},
              
            
            ]
          }
        ]
      },
      {
        path:"radiographySystem",
        children: [
          {path:"radiographySystemBase",element:<RadiographySystemBase/>},
          {
            path: "dashboard",
            element: <RadiographySystem_Dashboard/>,
            children: [
            {path:"radiographySystemDashboard",element:<RadiographySystemDashboardContent/>},
            {path:"radiographySystemReception",element:<RadiographySystemReception/>},
            {path:"radiographySystemAppointment",element:<RadiographySystemAppointment/>},
            
            ]
          }
        ]
      },
      {
        path:"laboratorySystem",
        children: [
          {path:"laboratorySystemBase",element:<LaboratorySystemBase/>},
          {
            path: "dashboard",
            element: <LaboratorySystem_Dashboard/>,
            children: [
            {path:"laboratorySystemDashboard",element:<LaboratorySystemDashboardContent/>},
            {path:"laboratorySystemReception",element:<LaboratorySystemReception/>},
            {path:"laboratorySystemAppointment",element:<LaboratorySystemAppointment/>},
            
            ]
          }
        ]
      },
      {
        path:"drugstoreSystem",
        children: [
          {path:"drugstoreSystemBase",element:<DrugstoreSystemBase/>},
          {
            path: "dashboard",
            element: <DrugstoreSystem_Dashboard/>,
            children: [
            {path:"drugstoreSystemDashboard",element:<DrugstoreSystemDashboardContent/>},
            {path:"drugstoreSystemReception",element:<DrugstoreSystemReception/>},
            {path:"drugstoreSystemAppointment",element:<DrugstoreSystemAppointment/>},
            
            ]
          }
        ]
      },
      {
        path: "basePanle",
        children: [
          { path: "home", element: <BasePanel />,children:[
            { path: "baseUserQuizzes", element: <BaseUserQuizzes /> },
            { path: "baseUserAccount", element: <BaseUserAccount /> },
            { path: "baseUserLoans", element: <BaseUserLoans /> },
          ]},
          
          { path: "walletCallBack", element: <WalletCallBack /> },
          { path: "walletCallBackLoan", element: <WalletCallBackLoan /> },
         ]},
      { path: "*", element: <NotFound /> },
    ]);
  }

  // IMPORT COMPONENTS Layout
  const Layout = Loadable(lazy(() => import("../layout/Layout")));
  const HomePage =Loadable(lazy(() => import("../views/Home/HomePage")));
  const HP_Template =Loadable(lazy(() => import("../views/Home/HomePage_Camp/HP_Template")));
  const HomeAppointmentReservation =Loadable(lazy(() => import("../views/Home/AppointmentReservation")));
  const CentersAppointmentReservation =Loadable(lazy(() => import("../views/Home/CentersAppointmentReservation")));
  const UserQuizzes =Loadable(lazy(() => import("../views/Home/UserQuizzes")));
  const UserLoans =Loadable(lazy(() => import("../views/Home/UserLoans")));
  const UserHealthMonitoringAlgorithms =Loadable(lazy(() => import("../views/Home/UserHealthMonitoringAlgorithms")));
  const Qr =Loadable(lazy(() => import("../views/Home/Qr")));
   const DoctorQr =Loadable(lazy(() => import("../views/Home/DoctorQr")));
    // IMPORT COMPONENTS QuizMaster
    const Q_Dashboard =Loadable(lazy(() => import("../views/QuizMaster/QuizMasterDashboard")));
    const Quizzes =Loadable(lazy(() => import("../views/QuizMaster/Quizzes")));
    const Q_DashboardContent =Loadable(lazy(() => import("../views/QuizMaster/Dashboard")));
    const Q_Confirmation =Loadable(lazy(() => import("../views/QuizMaster/Confirmation")));
    const QuizMasterQuizCorrection =Loadable(lazy(() => import("../views/QuizMaster/QuizMasterQuizCorrection")));

  const CompletingAppointment =Loadable(lazy(() => import("../views/Home/CompletingAppointment")));
  const Login =Loadable(lazy(() => import("../LoginHome")));
  const AppointmentRules =Loadable(lazy(() => import("../views/shared/AppointmentRules")));

  // IMPORT COMPONENTS Doctor
  const D_Dashboard = Loadable(lazy(() => import("../views/Doctor/DcotorDashboard")));
  const DoctorBase =Loadable(lazy(()=> import("../views/Doctor/DoctorBace")));
  const DoctorVisit=Loadable(lazy(()=> import("../views/Doctor/DoctorVisit")));
  const ReportDoctor=Loadable(lazy(()=>import("../views/Doctor/ReportDoctor")))


    // IMPORT COMPONENTS HealthCenter
  const H_Dashboard = Loadable(lazy(() => import("../views/HealthCenter/HealthCenterDashboard")));
  const HealthCenterBase =Loadable(lazy(()=> import("../views/HealthCenter/HealthCenterBase")));
  const H_DashboardContent = Loadable(lazy(() => import("../views/HealthCenter/DashboardContent")));
const HealthCenterReceptions = Loadable(lazy(() => import("../views/HealthCenter/HealthCenterReceptions")));
    // IMPORT COMPONENTS Organization
  const O_DashboardContent = Loadable(lazy(() => import("../views/Organization/DashboardContent")));
  const OrganizationBase =Loadable(lazy(()=> import("../views/Organization/OrganizationBase")));
  const O_Dashboard=Loadable(lazy(()=> import("../views/Organization/OrganizationDashboard")));
  const OrganizationPatients=Loadable(lazy(()=> import("../views/Organization/OrganizationPatients")));
  const OrganizationReport=Loadable(lazy(()=> import("../views/Organization/OrganizationReport")));
  const OrganizationCharts=Loadable(lazy(()=> import("../views/Organization/OrgChart")));
        // IMPORT COMPONENTS OrganizationSystem
  const OrgSystem_DashboardContent = Loadable(lazy(() => import("../views/OrganizationSystem/DashboardContent")));
  const OrganizationSystemBase =Loadable(lazy(()=> import("../views/OrganizationSystem/OrganizationSystemBase")));
  const OrgSystem_Dashboard=Loadable(lazy(()=> import("../views/OrganizationSystem/OrganizationSystemDashboard")));
  const OrganizationSystemPatients=Loadable(lazy(()=> import("../views/OrganizationSystem/OrganizationSystemPatients")));
  const OrganizationSystemReport=Loadable(lazy(()=> import("../views/OrganizationSystem/OrganizationSystemReport")));
const OrganizationSystemCharts=Loadable(lazy(()=> import("../views/OrganizationSystem/OrgSystemChart")));
  const DashboardContentDoctor=Loadable(lazy(()=> import("../views/Doctor/DashboardContent")));
  const OfficePatients=Loadable(lazy(()=> import("../views/Doctor/OfficePatients")));
  const ListIntroducesDoctor=Loadable(lazy(()=> import("../views/Doctor/ListIntroducedDoctor")));

  // IMPORT COMPONENTS Secretary
  const S_Dashboard= Loadable(lazy(()=> import("../views/Secretary/SecretaryDashboard")));
  const SecretaryBase=Loadable(lazy(()=> import("../views/Secretary/SecretaryBase")));
  const DashboardContent=Loadable(lazy(()=> import("../views/Secretary/DashboardContent")));
  const SecretaryPatients=Loadable(lazy(()=> import("../views/Secretary/SecretaryPatients")));
  const SecretaryAppointments=Loadable(lazy(()=> import("../views/Secretary/SecretaryAppointments")));
  const ListSecretaryAppointmentsAll=Loadable(lazy(()=> import("../views/Secretary/ListSecretaryAppointment")));

  const PatientMedicalInformation=Loadable(lazy(()=> import("../views/Secretary/PatientMedicalInformation")));
  const SecretaryPatientBoard=Loadable(lazy(()=> import("../views/Secretary/SecretaryPatientBoard")));

  // IMPORT COMPONENTS Patient
  const P_Dashboard=Loadable(lazy(()=> import("../views/Patients/PatientsDashboard")));
  const PatientAppointment=Loadable(lazy(()=> import("../views/Patients/PatientAppointment")));
  const Patient=Loadable(lazy(()=> import("../views/Patients/Patient")));
  const AppointmentReservation=Loadable(lazy(()=> import("../views/Patients/AppointmentReservation")));
  const Confirmation=Loadable(lazy(()=> import("../views/Patients/Confirmation")));
  const CallBack=Loadable(lazy(()=> import("../views/Home/CallBack")));

  // IMPORT COMPONENTS Supporter
  const Sup_Dashboard=Loadable(lazy(()=> import("../views/Supporter/SupporterDashboard")));
  const PatientSupporter=Loadable(lazy(()=> import ("../views/Supporter/PatientSupporter")));
  const DashboardContent_Supporter=Loadable(lazy(()=> import ("../views/Supporter/DashboardContent")));
  const SettlementRequest=Loadable(lazy(()=> import ("../views/Supporter/SettlementRequest")));
  const SupporterReport=Loadable(lazy(()=> import ("../views/Supporter/SupporterReport")));
  const SupportContract=Loadable(lazy(()=> import ("../views/Supporter/SupportContract")));

  // IMPORT COMPONENTS RadiologySystem
  const RadiographySystem_Dashboard=Loadable(lazy(()=> import("../views/RadiographySystem/RadiographySystemDashboard")));
  const RadiographySystemDashboardContent=Loadable(lazy(()=> import("../views/RadiographySystem/DashboardContent")));
  const RadiographySystemBase=Loadable(lazy(()=> import("../views/RadiographySystem/RadiographySystemBase")));
  const RadiographySystemReception=Loadable(lazy(()=> import ("../views/RadiographySystem/RadiographySystemReception")));
  const RadiographySystemAppointment=Loadable(lazy(()=> import ("../views/RadiographySystem/RadiographySystemAppointment")));

  // IMPORT COMPONENTS LablatorySystem
  const LaboratorySystem_Dashboard=Loadable(lazy(()=> import("../views/LaboratorySystem/LaboratorySystemDashboard")));
  const LaboratorySystemDashboardContent=Loadable(lazy(()=> import("../views/LaboratorySystem/DashboardContent")));
  const LaboratorySystemBase=Loadable(lazy(()=> import("../views/LaboratorySystem/LaboratorySystemBase")));
  const LaboratorySystemReception=Loadable(lazy(()=> import ("../views/LaboratorySystem/LaboratorySystemReception")));
  const LaboratorySystemAppointment=Loadable(lazy(()=> import ("../views/LaboratorySystem/LaboratorySystemAppointment")));

  // IMPORT COMPONENTS DrugStoreSystem
  const DrugstoreSystem_Dashboard=Loadable(lazy(()=> import("../views/DrugstoreSystem/DrugstoreSystemDashboard")));
  const DrugstoreSystemDashboardContent=Loadable(lazy(()=> import("../views/DrugstoreSystem/DashboardContent")));
  const DrugstoreSystemBase=Loadable(lazy(()=> import("../views/DrugstoreSystem/DrugstoreSystemBase")));
  const DrugstoreSystemReception=Loadable(lazy(()=> import ("../views/DrugstoreSystem/DrugstoreSystemReception")));
  const DrugstoreSystemAppointment=Loadable(lazy(()=> import ("../views/DrugstoreSystem/DrugstoreSystemAppointment")));

  // IMPORT COMPONENTS Radiology
  const Radiography_Dashboard=Loadable(lazy(()=> import("../views/Radiography/RadiographyDashboard")));
  const RadiographyDashboardContent=Loadable(lazy(()=> import("../views/Radiography/DashboardContent")));
  const RadiographyBase=Loadable(lazy(()=> import("../views/Radiography/RadiographyBase")));
  const RadiographyReception=Loadable(lazy(()=> import ("../views/Radiography/RadiographyReception")));
  const RadiographyAppointment=Loadable(lazy(()=> import ("../views/Radiography/RadiographyAppointment")));

  // IMPORT COMPONENTS Lablatory
  const Laboratory_Dashboard=Loadable(lazy(()=> import("../views/Laboratory/LaboratoryDashboard")));
  const LaboratoryDashboardContent=Loadable(lazy(()=> import("../views/Laboratory/DashboardContent")));
  const LaboratoryBase=Loadable(lazy(()=> import("../views/Laboratory/LaboratoryBase")));
  const LaboratoryReception=Loadable(lazy(()=> import ("../views/Laboratory/LaboratoryReception")));
  const LaboratoryAppointment=Loadable(lazy(()=> import ("../views/Laboratory/LaboratoryAppointment")));

  // IMPORT COMPONENTS DrugStore
  const Drugstore_Dashboard=Loadable(lazy(()=> import("../views/Drugstore/DrugstoreDashboard")));
  const DrugstoreDashboardContent=Loadable(lazy(()=> import("../views/Drugstore/DashboardContent")));
  const DrugstoreBase=Loadable(lazy(()=> import("../views/Drugstore/DrugstoreBase")));
  const DrugstoreReception=Loadable(lazy(()=> import ("../views/Drugstore/DrugstoreReception")));
  const DrugstoreAppointment=Loadable(lazy(()=> import ("../views/Drugstore/DrugstoreAppointment")));


  // IMPORT COMPONENTS Lender
  const Lender_Dashboard=Loadable(lazy(()=> import("../views/Lender/LenderDashboard")));
  const LenderDashboardContent=Loadable(lazy(()=> import("../views/Lender/DashboardContent")));
  const LenderBase=Loadable(lazy(()=> import("../views/Lender/LenderBase")));
  const LenderLoan=Loadable(lazy(()=> import("../views/Lender/LenderLoan")));
  const LenderLoanRequest=Loadable(lazy(()=> import("../views/Lender/LenderRequest")));

  // IMPORT COMPONENTS LenderSystem
  const LenderSystem_Dashboard=Loadable(lazy(()=> import("../views/LenderSystem/LenderSystemDashboard")));
  const LenderSystemDashboardContent=Loadable(lazy(()=> import("../views/LenderSystem/DashboardContent")));
  const LenderSystemBase=Loadable(lazy(()=> import("../views/LenderSystem/LenderSystemBase")));
  const LenderSystemLoan=Loadable(lazy(()=> import("../views/LenderSystem/LenderSystemLoan")));
  const LenderSystemLoanRequest=Loadable(lazy(()=> import("../views/LenderSystem/LenderSystemLoanRequest")));

  // IMPORT  COMPONENTS ADMIN
  const Admin_Login = Loadable(lazy(() => import("../views/pages/Admin/login")));
  const ListBaseUserAddress = Loadable(lazy(() => import("../views/pages/BaseUser/ListBaseUserAddress")));
  const Dashboard = Loadable(lazy(() => import("../views/pages/Admin/Dashboard")));
  const ListProvince = Loadable( lazy(() => import("../views/pages/Province/ListProvince")));
  const ListCities = Loadable(lazy(() => import("../views/pages/Cities/ListCities")));
  const ListJobGroups = Loadable(lazy(() => import("../views/pages/Jobs/ListJobGroup")));
  const ListJob = Loadable(lazy(() => import("../views/pages/Jobs/ListJob")));
  const ListInsurances = Loadable(lazy(() => import("../views/pages/Insurances/ListInsurances")));
  const ListDegree = Loadable(lazy(() => import("../views/pages/Degree/ListDegree")));
  const ListGender = Loadable(lazy(() => import("../views/pages/Gender/ListGender")));
  const ListOrganizationTypes = Loadable(lazy(() => import("../views/pages/OrganizationTypes/ListOrganizationTypes")));
  const ListBaseUser = Loadable(lazy(() => import("../views/pages/BaseUser/ListBaseUser")));
  const ListMainBodyParts=Loadable(lazy(()=> import("../views/pages/MainBodyPart/ListMainBodyParts")));
  const ListBodyParts=Loadable(lazy(()=> import("../views/pages/MainBodyPart/ListBodyParts")));
  const ListReceptionTypes=Loadable(lazy(()=> import("../views/pages/ReceptionTypes/ListReceptionTypes")));
  const ListPaymentTypes=Loadable(lazy(()=> import("../views/pages/PaymentTypes/ListPaymentTypes")));
  const ListDrugType=Loadable(lazy(()=> import('../views/pages/Drug/ListDrugType')));
  const ListDrugTimes=Loadable(lazy(()=> import('../views/pages/Drug/ListDrugTimes')));
  const ListDrugDosages=Loadable(lazy(()=> import('../views/pages/Drug/ListDrugDosages')));
  const ListTestCategories=Loadable(lazy(()=>import('../views/pages/Test/ListTestCategories')));
  const ListTests=Loadable(lazy(()=>import('../views/pages/Test/ListTests')));
  const ListAdmin=Loadable(lazy(()=>import("../views/pages/Admin/ListAdmin")));
  const ListSecretaries=Loadable(lazy(()=>import("../views/pages/BaseUser/ListSecretaries")));
  const ListDiseaseCategories=Loadable(lazy(()=>import("../views/pages/Disease/ListDiseaseCategories")))
  const ListDisease=Loadable(lazy(()=>import("../views/pages/Disease/ListDisease")));
  const ListSymptoms=Loadable(lazy(()=>import("../views/pages/Symptoms/ListSymptoms")));
  const ListDrugCategories=Loadable(lazy(()=>import("../views/pages/Drug/ListDrugCategories")));
  const ListHealthCenters=Loadable(lazy(()=> import("../views/pages/HealthCenter/ListHealthCenter")));
  const HealthCenterService=Loadable(lazy(()=> import("../views/pages/HealthCenter/HealthCenterService")));
  const ListHealthCenterService=Loadable(lazy(()=> import("../views/pages/HealthCenter/ListHealthCenterService")));
  const ListHealthCenterServices=Loadable(lazy(()=> import("../views/pages/HealthCenter/ListHealthCenterServices")));
  const ListHealthCenterServiceCategory=Loadable(lazy(()=> import("../views/pages/HealthCenter/ListHealthCenterServiceCategory")));
  const ListHealthCenterServiceInsurances=Loadable(lazy(()=> import("../views/pages/HealthCenter/ListHealthCenterServiceInsurances")));
  const ListHealthCenterPart=Loadable(lazy(()=> import("../views/pages/HealthCenter/ListHealthCenterPart")));
  const ListHealthCenterRoomType=Loadable(lazy(()=> import("../views/pages/HealthCenter/ListHealthCenterRoomType")));
  const ListHealthCenterRoom=Loadable(lazy(()=> import("../views/pages/HealthCenter/ListHealthCenterRoom")));
  const ListHealthCenterBed=Loadable(lazy(()=> import("../views/pages/HealthCenter/ListHealthCenterBed")));
  const ListRoles=Loadable(lazy(()=> import("../views/pages/Roles/ListRoles")));
  const ListUserRole=Loadable(lazy(()=> import ("../views/pages/Roles/ListUserRole")));
  const ListPatients=Loadable(lazy(()=> import ("../views/pages/BaseUser/ListPatients")));
  const ListQuizMaster=Loadable(lazy(()=> import ("../views/pages/BaseUser/ListQuizMaster")));
  const ListDoctors=Loadable(lazy(()=> import("../views/pages/BaseUser/ListDoctor")));
  const ListLaboratories=Loadable(lazy(()=> import("../views/pages/BaseUser/ListLaboratories")));
  const ListDrugstores=Loadable(lazy(()=> import("../views/pages/BaseUser/ListDrugstores")));
  const ListMatab=Loadable(lazy(()=>import("../views/pages/BaseUser/ListMatab")));
  const ListRadiography=Loadable(lazy(()=> import ("../views/pages/BaseUser/ListRadiography")));
  const ListMedicalSystems=Loadable(lazy(()=> import ("../views/pages/BaseUser/ListMedicalSystems")));
  const ListFellowships=Loadable(lazy(()=> import ("../views/pages/Fellowships/ListFellowships")));
  const ListRadiologyCategories=Loadable(lazy(()=> import ("../views/pages/Radiology/ListRadiologyCategories")));
  const ListPatientSmokeHistories=Loadable(lazy(()=> import ("../views/pages/PatientHistories/ListPatientSmokeHistories")));
  const ListPatientWeightHistories=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientWeightHistories")));
  const ListPeriods=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPeriods")));
  const ListTestAnswerByPatients=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListTestAnswerByPatients")));
  const ListRadiologyAnswerByPatients=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListRadiologyAnswerByPatients")));
  const ListSupporters=Loadable(lazy(()=> import("../views/pages/BaseUser/ListSupporters")));
  const ListSupportContracts=Loadable(lazy(()=> import ("../views/pages/BaseUser/ListSupportContracts")));
  const ListExpertise=Loadable(lazy(()=> import("../views/pages/Expertise/ListExpertise")));
  const ListPatientDrugs=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientDrugs")));
  const ListDoctorDiseaseRadiology=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorDiseaseRadiology")));
  const ListDoctorDiseaseTest=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorDiseaseTest")));
  const ListDoctorExpertise=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorExpertise")));
  const ListDoctorFellowships=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorFellowships")));
  const ListDoctorsServicesCategories=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorsServicesCategories")));
  const ListDoctorsServices=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorsServices")));
  const ListDoctorServices=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorServices")));
  const ListDoctorServiceInsurances=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorServiceInsurances")));
  const ListDiseaseDoctors=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDiseaseDoctors")));
  const ListDiagnosis=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDiagnosis")));
  const ListDoctorIntroducePatients=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorIntroducePatients")))
  const ListTestFormula=Loadable(lazy(()=> import("../views/pages/Test/ListTestFormula")))

  const ListTimeOfDay=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListTimeOfDay")))
  const ListAltitude=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListAltitude")))

  const ListPatientOperates=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientOperates")));
  const ListDiseaseTests=Loadable(lazy(()=> import("../views/pages/Disease/ListDiseaseTests")));
  const ListDiseaseRadiology=Loadable(lazy(()=> import("../views/pages/Disease/ListDiseaseRadiology")));
  const ListRadiology=Loadable(lazy(()=> import("../views/pages/Radiology/ListRadiology")));
  const ListDrug=Loadable(lazy(()=> import("../views/pages/Drug/ListDrugs")));
  const ListDrugInstructions=Loadable(lazy(()=> import("../views/pages/Drug/ListDrugInstructions")));
  const ListDoctorDiseaseDrugs=Loadable(lazy(()=> import("../views/pages/DoctorHistories/ListDoctorDiseaseDrugs")));
  const ListDiseaseSymptoms=Loadable(lazy(()=> import("../views/pages/Disease/ListDiseaseSymptoms")));
  const ListDrugstoreDrugs=Loadable(lazy(()=> import("../views/pages/Drug/ListDrugstoreDrugs")));
  const ListRolePermission=Loadable(lazy(()=> import("../views/pages/Roles/ListRolePermission")));
  const ListPermissionCategoryPermissions=Loadable(lazy(()=> import("../views/pages/Roles/ListPermissionCategoryPermissions")));
  const ListSupportRequestSettlements=Loadable(lazy(()=> import("../views/pages/SupportRequest/ListSupportRequestSettlements")));
  const ListReceptions=Loadable(lazy(()=> import("../views/pages/ReceptionTypes/ListReceptions")));
  const ListDiseaseDrugs=Loadable(lazy(()=> import("../views/pages/Disease/ListDiseaseDrugs")));
  const ListDrugSimilar=Loadable(lazy(()=> import("../views/pages/Drug/ListDrugSimilar")));
  const ListDrugInteraction=Loadable(lazy(()=> import("../views/pages/Drug/ListDrugInteraction")));
  const ListTestDetails=Loadable(lazy(()=> import("../views/pages/Test/ListTestDetails")));
  const VisitFormPage=Loadable(lazy(()=> import("../views/pages/VisitForm/VisitFormPage")));
  const DoctorVisitFormPage=Loadable(lazy(()=> import("../views/pages/VisitForm/DoctorVisitFormPage")));
  const ListAppointmentPatient=Loadable(lazy(()=> import("../views/pages/AppointmentPatient/ListAppointmentPatient")));
  const ListAppointments=Loadable(lazy(()=> import("../views/pages/AppointmentPatient/ListAppointments")));
  const ListAppointmentDetails=Loadable(lazy(()=> import("../views/pages/AppointmentPatient/ListAppointmentDetails")));
  const ListAppointmentOnlineType=Loadable(lazy(()=> import("../views/pages/AppointmentPatient/ListAppointmentOnlineType")));
  const ListBloodGroups=Loadable(lazy(()=> import("../views/pages/BloodGroups/ListBloodGroups")));
  const ListExternalAppointmens=Loadable(lazy(()=> import("../views/pages/AppointmentPatient/ListExternalAppointmens")));
  const ListFamily=Loadable(lazy(()=> import("../views/pages/Family/ListFamily")));
  const ListRiskFactors=Loadable(lazy(()=> import("../views/pages/RiskFactors/ListRiskFactors")));
  const ListDiseaseRiskFactors=Loadable(lazy(()=> import("../views/pages/RiskFactors/ListDiseaseRiskFactors")));
  const ListDiseaseExpertise=Loadable(lazy(()=> import("../views/pages/DiseaseExpertise/ListDiseaseExpertise")));
  const ListLoanTypes=Loadable(lazy(()=> import("../views/pages/Loans/ListLoanTypes")));
  const ListLoanDocuments=Loadable(lazy(()=> import("../views/pages/Loans/ListLoanDocuments")));
  const ListLoans=Loadable(lazy(()=> import("../views/pages/Loans/ListLoans")));
  const ListLender=Loadable(lazy(()=> import("../views/pages/Loans/ListLender")));
  const ListMedicalLaboratoryTitle=Loadable(lazy(()=> import("../views/pages/MedicalTitle/ListMedicalLaboratoryTitle")));
  const ListMedicalRadiographyTitle=Loadable(lazy(()=> import("../views/pages/MedicalTitle/ListMedicalRadiographyTitle")));
  const ListReferralCategories=Loadable(lazy(()=> import("../views/pages/Referral/ListReferralCategories")));
  const ListReferrals=Loadable(lazy(()=> import("../views/pages/Referral/ListReferral")));
  const ListFinancialCenter=Loadable(lazy(()=> import("../views/pages/FinancialCenter/ListFinancialCenter")));
  const ListBank=Loadable(lazy(()=> import("../views/pages/FinancialCenter/ListBank")));
  const ListCreditPoints=Loadable(lazy(()=> import("../views/pages/FinancialCenter/ListCreditPoints")));
  const ListBankAccounts=Loadable(lazy(()=> import("../views/pages/FinancialCenter/ListBankAccounts")));
  const ListComment=Loadable(lazy(()=> import("../views/pages/Comment/ListComment")));
  const ListQuizPanel=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuizPanel")));
  const ListQuizMasterQuizPanel=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuizMasterQuizPanel")));
  const ListQuizCategoryDetails=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuizCategoryDetails")));
  const ListQuizCategory=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuizCategory")));
  const ListQuestionType=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuestionType")));
  const ListQuizType=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuizType")));  
  const ListCourseCategories=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListCourseCategories")));
  const ListCourse=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListCourse")));
  const ListLevelScore=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListLevelScore")));
  const ListQuiz=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuiz")));
  const ListQuizCourse=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuizCourse")));
  const ListQuizCourseScore=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuizCourseScore")));
  const ListQuizScore=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuizScore")));
  const ListQuestion=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuestion")));
  const ListQuizQuestion=Loadable(lazy(()=> import("../views/pages/QuizPanel/ListQuizQuestion")));
  const AdminQuizCorrection=Loadable(lazy(()=> import("../views/pages/QuizPanel/AdminQuizCorrection")));
  const ListPatientTest=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientTest")));
  const ListPatientRadiology=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientRadiology")));
  const ListInnocence=Loadable(lazy(()=> import("../views/pages/Innocence/ListInnocence")));
  const ListOrganizationCategory=Loadable(lazy(()=> import("../views/pages/Organizations/ListOrganizationCategory")));
  const ListOrganization=Loadable(lazy(()=> import("../views/pages/Organizations/ListOrganization")));
  const ListOrganizationDoctor=Loadable(lazy(()=> import("../views/pages/Organizations/ListOrganizationDoctor")));
  const ListOrganizationRoom=Loadable(lazy(()=> import("../views/pages/Organizations/ListOrganizationRoom")));
  const ListOrganizationSystem=Loadable(lazy(()=> import("../views/pages/Organizations/ListOrganizationSystem")));
  const ListOrganizationPatients=Loadable(lazy(()=> import("../views/pages/Organizations/ListOrganizationPatients")));
  const ListOrganizationServantContract=Loadable(lazy(()=> import("../views/pages/Organizations/ListOrganizationServantContract")));
  const ListSocialMedia=Loadable(lazy(()=> import("../views/pages/SocialMedia/ListSocialMedia")));
  const ListFrequentlyQuestionCategories=Loadable(lazy(()=> import("../views/pages/FrequentlyQuestions/ListFrequentlyQuestionCategories")));
  const ListSupportInformation=Loadable(lazy(()=> import("../views/pages/SupportInformation/ListSupportInformation")));

  const ListFrequentlyQuestions=Loadable(lazy(()=> import("../views/pages/FrequentlyQuestions/ListFrequentlyQuestions")));
  
  const ListEquipments=Loadable(lazy(()=> import("../views/pages/Equipments/ListEquipments")));
  const ListEquipmentGroups=Loadable(lazy(()=> import("../views/pages/Equipments/ListEquipmentGroups")));
  const ListServiceEquipments=Loadable(lazy(()=> import("../views/pages/Equipments/ListServiceEquipments")));
  const ListPoliclinicEquipments=Loadable(lazy(()=> import("../views/pages/Equipments/ListPoliclinicEquipments")));
  const ListPatientEquipmentSalesInvoices=Loadable(lazy(()=> import("../views/pages/Equipments/ListPatientEquipmentSalesInvoices")));
  
  const ListSmsPanels=Loadable(lazy(()=> import("../views/pages/SmsPanels/ListSmsPanels")));
  const ListNurse=Loadable(lazy(()=> import("../views/pages/Nurse/ListNurse")));
  const ListHealthRecordCategory=Loadable(lazy(()=> import("../views/pages/HealthRecord/ListHealthRecordCategory")));
  const ListHealthRecordCategoryDetails=Loadable(lazy(()=> import("../views/pages/HealthRecord/ListHealthRecordCategoryDetail")));
  const ListHealthRecord=Loadable(lazy(()=> import("../views/pages/HealthRecord/ListHealthRecord")));
const ListActivityType=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListActivityType")));
const ListEcg=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListEcg")));
const ListInjectionType=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListInjectionType")));
const ListInjectionBodyPart=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListInjectionBodyPart")));
const ListManufacturer=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListManufacturer")));
const ListPupilSize=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListPupilSize")));
const ListSkinObservation=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListSkinObservation")));
const ListPatientVaccineHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientVaccineHistory")));
const ListVaccine=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListVaccine")));
const ListVaccineType=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListVaccineType")));
const ListVaccineDoseType=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListVaccineDoseType")));
const ListVaccineDoseSchedule=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListVaccineDoseSchedule")));
const ListMeasurementUnit=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListMeasurementUnit")));
const ListPatientSleepQualityHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientSleepQualityHistory")));
const ListUnitConversions=Loadable(lazy(()=> import("../views/pages/MedicalOperation/ListUnitConversions")));
const ListPatientActivityHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientActivityHistory")));
const ListPatientBloodPressureHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientBloodPressureHistory")));
const ListPatientBloodSugarHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientBloodSugarHistory")));
const ListPatientConsciousnessLevelHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientConsciousnessLevelHistory")));
const ListPatientSkinObservationHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientSkinObservationHistory")));
const ListPatientPupilCheckHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientPupilCheckHistory")));
const ListPatientRespiratoryRateHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientRespiratoryRateHistory")));
const ListPatientEcgHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientEcgHistory")));
const ListPatientFluidBalanceHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientFluidBalanceHistory")));
const ListPatientHealthNote=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientHealthNote")));
const ListPatientHeartRateHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientHeartRateHistory")));
const ListPatientPainScoreHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientPainScoreHistory")));
const ListPatientOxygenSaturationHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientOxygenSaturationHistory")));
const ListPatientBloodOxygenLevelHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientBloodOxygenLevelHistory")));
const ListPatientBodyTemperatureHistory=Loadable(lazy(()=> import("../views/pages/PatientHistories/ListPatientBodyTemperatureHistory")));
const ListHealthMonitoringAlgorithms=Loadable(lazy(()=> import("../views/pages/HealthMonitoringAlgorithms/ListHealthMonitoringAlgorithms")));

const ListPatientHealthMonitorings=Loadable(lazy(()=> import("../views/pages/HealthMonitoringAlgorithms/ListPatientHealthMonitorings")));
const ListMenstrualCycle=Loadable(lazy(()=> import("../views/pages/MenstrualCycle/ListMenstrualCycle")));
const ListPackages=Loadable(lazy(()=> import("../views/pages/Packages/ListPackages")));
const ListTestDeviceCategory=Loadable(lazy(()=> import("../views/pages/Labs/ListTestDeviceCategory")));
  // IMPORT LOGIN AND REGISTER COMPONENTS

  //const RegisterUsers = Loadable(lazy(() => import("../views/components/Login_App/LoginRegister_Component")));
  const LoginAndRegisterUsers = Loadable(lazy(() => import("../components/Login/Login")));

  // IMPORT PERSONS BASE
  const BasePanel = Loadable(lazy(() => import("../views/pages/BasePanle/BasePanle")));
  const WalletCallBack = Loadable(lazy(() => import("../views/pages/BasePanle/WalletCallBack")));
  const WalletCallBackLoan = Loadable(lazy(() => import("../views/pages/BasePanle/WalletCallBackLoan")));
  const BaseUserQuizzes = Loadable(lazy(() => import("../views/pages/BasePanle/Quizzes")));
  const BaseUserAccount = Loadable(lazy(() => import("../views/pages/BasePanle/BaseUserAccount")));
  const BaseUserLoans = Loadable(lazy(() => import("../views/pages/BasePanle/Loans")));
